import React, { useContext, useEffect, useState } from "react";
import { Button, Paragraph, Spacing, Title } from "@sicredi/react";
import { ButtonLinkChevronRight } from "#/components/ButtonLinkChevronRight";
import { ContextAPI } from "#/contextProver/ContextProver";
import {
  formatDate,
  getListaPaginacaoListaProposta,
  getTotalPaginas,
  handleGoAppStore,
} from "#/contextProver/ContextProverServices";
import { CardMenuConsorcio } from "#/components/CardMenuConsorcio";
import styles from "./styles.module.scss";
import { dataForProducts } from "#/utils/dataForProducts";
import { StatusIcon } from "#/components/CardMenuConsorcio/model";
import { useNavigate } from "react-router-dom";
import { PAGE } from "#/constants";
import dayjs from "dayjs";

export const MenuConsorcio: React.FC = () => {
  const { vendasListaProposta } = useContext(ContextAPI);
  const navigate = useNavigate();
  const [atualPagina, setAtualPagina] = useState(1);
  const quantidadePorPagina = 5;

  const propostaNaoCancelada = () => {
    if (vendasListaProposta.data) {
      return vendasListaProposta.data.filter(
        (item) => item.dataCancelamentoProposta === "0001-01-01 00:00:00"
      );
    } else {
      return [];
    }
  };

  const vendasListaPropostaPaginacao = getListaPaginacaoListaProposta({
    apiLista: propostaNaoCancelada(),
    atualPagina,
    quantidadePorPagina,
  });

  const totalPaginas = getTotalPaginas({
    quantidadeLista: propostaNaoCancelada().length,
    quantidadePorPagina,
  });

  useEffect(() => {
    if (!vendasListaProposta.data) {
      navigate(PAGE.ROOT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={styles.container}>
        <Title
          size={"xxx-large"}
          as="h1"
          weight={"semi-bold"}
          className={styles.title}
        >
          Meu Consórcio
        </Title>
        <Title
          size={"large"}
          as="h4"
          weight={"light"}
          className={styles.sub_title}
        >
          Acompanhe as simulações e contratações feitas por aqui.
        </Title>
        <div className={styles.content_cards}>
          {vendasListaPropostaPaginacao?.map((item, index) => {
            const currentDate = dayjs();
            const dataPrimeiraAssembleiaAddDay = dayjs(
              item.dataPrimeiraAssembleia
            ).add(1, "day");

            const isPendingSignature = item.contratoAssinado === "N";

            const isPendingBilletGenerate =
              item.contratoAssinado === "S" &&
              item.boletoGerado === "N" &&
              item.boletoPago === "N" &&
              item.dataVencimetoBoletoAdesao === "0001-01-01 00:00:00";

            const isPendingPayment =
              item.contratoAssinado === "S" &&
              item.boletoGerado === "S" &&
              item.boletoPago === "N" &&
              item.dataVencimetoBoletoAdesao !== "0001-01-01 00:00:00";

            const isContractDoneSuccessfully =
              item.boletoGerado === "S" &&
              item.boletoPago === "S" &&
              item.contratoAssinado === "S" &&
              (dataPrimeiraAssembleiaAddDay.isSame(currentDate, "day") ||
                dataPrimeiraAssembleiaAddDay.isAfter(currentDate, "day"));

            return (
              <div key={index}>
                {isPendingSignature && (
                  <CardMenuConsorcio
                    title={dataForProducts[item?.idProduto]?.titleCard}
                    description="A assinatura do contrato ainda está pendente."
                    statusIcon={StatusIcon.warning}
                    textIcon="Assinatura pendente"
                    idProduto={item.idProduto}
                    idDocumento={item.idDocumento}
                  />
                )}

                {isPendingBilletGenerate && (
                  <CardMenuConsorcio
                    title={dataForProducts[item?.idProduto]?.titleCard}
                    description={`Boleto de Adesão está disponível para emissão. Após o pagamento, aguarde a compensação.`}
                    statusIcon={StatusIcon.warning}
                    textIcon="Pagamento pendente"
                    idProduto={item.idProduto}
                    idDocumento={item.idDocumento}
                  />
                )}

                {isPendingPayment && (
                  <CardMenuConsorcio
                    title={dataForProducts[item?.idProduto]?.titleCard}
                    description={`Seu boleto de adesão está disponível para pagamento até ${formatDate(
                      item.dataVencimetoBoletoAdesao
                    )}. Após o pagamento, aguarde a compensação.`}
                    statusIcon={StatusIcon.warning}
                    textIcon="Pagamento pendente"
                    idProduto={item.idProduto}
                    idDocumento={item.idDocumento}
                  />
                )}

                {isContractDoneSuccessfully && (
                  <CardMenuConsorcio
                    title={dataForProducts[item?.idProduto]?.titleCard}
                    description={`Grupo ${item.cdGrupo}`}
                    descriptionSecondLine={`Cota ${item.cdCota}`}
                    statusIcon={StatusIcon.success}
                    textIcon="Contratado"
                    idProduto={item.idProduto}
                    idDocumento={item.idDocumento}
                  />
                )}
              </div>
            );
          })}
        </div>

        {atualPagina !== totalPaginas ? (
          <div className={styles.button_page_container}>
            <ButtonLinkChevronRight
              text="Carregar propostas"
              onClick={() => setAtualPagina(atualPagina + 1)}
              marginTop={0}
            />
          </div>
        ) : (
          <Spacing appearance="small" />
        )}
        <Button
          className={styles.button}
          onClick={() => navigate(PAGE.ROOT)}
          appearance="primary"
          block={true}
        >
          <p className={styles.text_button}>Nova simulação</p>
        </Button>
        <Spacing appearance="x-small" />
        <Button
          className={styles.button}
          onClick={handleGoAppStore}
          appearance="secondary"
          block={true}
        >
          <p className={styles.text_button}>Acessar App do Consórcio</p>
        </Button>

        <div className={styles.paragraph_footer}>
          <Paragraph size="small" weight="normal">
            As simulações pendentes serão canceladas automaticamente após a data
            de vencimento do boleto de adesão.
          </Paragraph>
        </div>
      </div>
    </>
  );
};
